export const company = {
  name: "Xi'an GyroNavi Technology Co., Ltd.",
  brand: 'GyroNavi',
  domain: 'gyronavi.com',
  contact: 'Frank',
  email: 'Frank@gyronavi.com',
  managerName: 'Manager Shi',
  managerEmail: '691018839@qq.com',
  phone: '+86 13572285750',
  phoneDisplay: '+86 135 7228 5750',
  whatsapp: '+86 13572285750',
  whatsappUrl: 'https://wa.me/8613572285750',
  wechat: '13572285750',
  location: "Xi'an, Shaanxi, China",
  founded: 2009,
  hours: 'Mon-Fri: 9:00 AM - 6:00 PM (GMT+8)',
  quoteTerms: 'USD FOB',
  maxAutoDiscount: 10
};

export const navigation = [
  { label: 'Home', path: '/' },
  { label: 'Products', path: '/products' },
  { label: 'Blog', path: '/blog' },
  { label: 'About Us', path: '/company' },
  { label: 'Contact', path: '/contact' }
];
